import { format } from 'date-fns'
import { walkFilterPath } from '../utils'

const buildFilterEventData = (rawData) => {
  const name = `Filter: ${rawData[0]}`
  const nameLC = name.toLowerCase()
  const analyticsData = {
    name,
    data: undefined,
  }

  if (nameLC.indexOf('channels') > -1) {
    const channel = rawData[1]
    const account = rawData[2]
    if (channel && account) {
      analyticsData.data = { channel, account }
    }
  } else if (nameLC.indexOf('labels') > -1) {
    const labelSet = rawData[1]
    const label = rawData[2]
    if (labelSet && label) {
      analyticsData.data = { labelSet, label }
    }
  } else if (nameLC.indexOf('approval status') > -1) {
    const status = rawData[1]
    if (status) {
      analyticsData.data = { status }
    }
  } else if (nameLC.indexOf('delivery status') > -1) {
    const status = rawData[1] || ''
    if (status) {
      analyticsData.data = { status }
    }
  }

  return analyticsData
}

export const parseFilterEvent = (currentPath, rootTree) => {
  const pathNames = []

  // walk the path by filter IDs to find the names of each filter
  walkFilterPath(currentPath, rootTree, (tree, i) => {
    const nextTree = (tree.childOptions ? tree.childOptions : tree).find(
      (subtree) => subtree.id === currentPath[i]
    )
    if (nextTree && nextTree.title) {
      pathNames.push(nextTree.title)
    }
    return nextTree
  })

  return buildFilterEventData(pathNames)
}

export const parseDateRangeEvent = (filterValues) => {
  const analyticsData = {
    name: 'Filter: Date Range',
    data: undefined,
  }
  const dateStart = filterValues.duration_starts_at
  const dateEnd = filterValues.duration_ends_at

  if (dateStart && dateEnd) {
    analyticsData.data = {
      dateRange:
        `${format(dateStart, 'MM/dd/yyyy')} ` +
        `- ${format(dateEnd, 'MM/dd/yyyy')}`,
    }
  }
  return analyticsData
}
